var map = {
	"./icons-svg/activity-logs.svg": 77821,
	"./icons-svg/admin.svg": 78738,
	"./icons-svg/backup-now.svg": 82204,
	"./icons-svg/close-icon.svg": 32838,
	"./icons-svg/delete-icon.svg": 39779,
	"./icons-svg/download.svg": 37886,
	"./icons-svg/edit.svg": 66241,
	"./icons-svg/overview.svg": 31933,
	"./icons-svg/recovery-menu.svg": 35241,
	"./icons-svg/recovery.svg": 38544,
	"./icons-svg/refresh.svg": 94457,
	"./icons-svg/responsive-restore-icon.svg": 66122,
	"./icons-svg/responsive-search-icon.svg": 34254,
	"./icons-svg/responsive-user-icon.svg": 54695,
	"./icons-svg/search.svg": 23775,
	"./icons-svg/seat-management.svg": 34568,
	"./icons-svg/users.svg": 25695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34354;